import ApiUtils from './apiUtils';
import base_url from '../baseUrls';

/**
 * Client for the `/gridLayouts` API, which stores each user's grid column layout
 * server side so it follows them between browsers and machines.
 *
 * Every call resolves to null on failure rather than throwing. A layout is a
 * convenience, so a grid must still render its default columns when the request
 * fails; the caller falls back to the cached copy in utils/gridLayoutStorage.
 */

const request = async (path, options)=> {
  try {
    const authToken = await ApiUtils.getAccessToken();
    if(!authToken) return null;

    const response = await fetch(`${base_url.api}gridLayouts${path}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: authToken,
      },
      ...options,
    });

    if(!response.ok) return null;

    return await response.json();
  } catch(e) {
    console.warn('Grid layout request failed.', e);
    return null;
  }
};

/**
 * Every layout belonging to the signed in user, as returned by the server.
 * The user is taken from the access token, so there is nothing to pass in.
 */
const fetchGridLayouts = async ()=> {
  const data = await request('/', {method: 'GET'});
  return data?.data?.gridLayouts || null;
};

const saveGridLayout = async (gridKey, columnState)=> {
  return request('/save', {
    method: 'POST',
    body: JSON.stringify({gridKey, columnState: JSON.stringify(columnState)}),
  });
};

const deleteGridLayout = async (gridKey)=> {
  return request('/delete', {
    method: 'POST',
    body: JSON.stringify({gridKey}),
  });
};

export {fetchGridLayouts, saveGridLayout, deleteGridLayout};
